import * as VeeValidate from "vee-validate";
import {
    required,
    required_if,
    length,
    min_value,
    max_value,
    email,
    oneOf
} from "vee-validate/dist/rules";
import { phone, date } from "./../validators";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Vue from "vue";
import i18n from "./../vue-i18n";
import en from "../../lang/forms/vee-validate.en";
import es from "../../lang/forms/vee-validate.es";
import EventBus from "./../eventbus";

VeeValidate.extend("required", required);
VeeValidate.extend("required_if", required_if);
VeeValidate.extend("length", length);
VeeValidate.extend("oneOf", oneOf);
VeeValidate.extend("min_value", min_value);
VeeValidate.extend("max_value", max_value);
VeeValidate.extend("email", email);

VeeValidate.extend("phone", {
    validate: (value, args) => phone(value, args.country),
    params: ["country"]
});

VeeValidate.extend("date", {
    validate: (value, args) => date(value, args.minDate, args.maxDate),
    params: ["minDate", "maxDate"]
});

VeeValidate.configure({
    classes: {
        valid: "is-valid",
        invalid: "is-invalid"
    }
});

VeeValidate.localize({ en, es });
VeeValidate.localize(i18n.locale);

EventBus.on("locale.changed", locale => VeeValidate.localize(locale));
EventBus.on("locale.changed", function() {
    this.$gtag.event("locale-changed", {
        event_category: "language",
        event_label: "language-switch"
    });
});

Vue.component("validation-observer", ValidationObserver);
Vue.component("validation-provider", ValidationProvider);
